export const ADD_LOGIN_USER = 'ADD_LOGIN_USER';
export const RESET_LOGIN = 'RESET_LOGIN';

export const addLoginUser = userParams => ({type: ADD_LOGIN_USER, userParams});
export const resetLogin = () => ({type: RESET_LOGIN});
